import React, { useState, useEffect } from "react"

export default ( { data, setFunction, active, label } ) => {

    return (
        <div className="toggle-btn-wrapper">
            {label &&
                <label for="">{label}</label>
            }
            <div className="items-wrapper">
                {data && data.map((item, i) => (
                    <div key={i} className={`toggle ${active == item.value ? ' active' : ''}`} onClick={() => setFunction(item.value)}>
                        {item.name}
                    </div>
                ))}
            </div>
        </div>
    )
}
